import { render } from "./WhatWeDo.vue?vue&type=template&id=71747ade"
import script from "./WhatWeDo.vue?vue&type=script&lang=js"
export * from "./WhatWeDo.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__